import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, CardText, Button, CardFooter, Input } from "reactstrap";

import { Page } from "components/common";
import { Trans } from "react-i18next";
import { AppsClient } from "services";
import { NotificationManager } from "react-notifications";
import { createPortal } from 'react-dom';
import SettingsModal, { DetailModal } from './SettingsModal'
import SyncModal from './SyncModal'
import store_logo from '../../assets/images/integration-icon.svg';
import BackButton from "components/refactoring/BackButton";
import { required_settings } from "./SettingsModal";
import { AvailableIntegrations, ConfiguredIntegrations } from "./Marn/List";
import { useUserContext } from "hooks";

function titleCase(word) {
  return word?.charAt(0)?.toUpperCase() + word?.substr(1)?.toLowerCase();
}

const dateFieldRequired = {
  loyverse: true,
  salla: true,
}

export const ApplicationsList = ({
  selectedOrganisation, xero, match, t, history, ...props
}) => {


  const apps_client = AppsClient()

  const [nonApps, setNonApps] = useState([])
  const [apps, setApps] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [domReady, setDomReady] = useState(false)
  const [search, setSearch] = useState('')

  const [current, setCurrent] = useState(null);
  const [settings_modal, setSettingsModal] = useState(false);
  const [details_modal, setDetailsModal] = useState(false);
  const [sync_modal, setSyncModal] = useState(false);
  const [showDateField, setShowDateField] = useState(false)
  const user = useUserContext()


  const toggleSettings = () => setSettingsModal(!settings_modal);
  const toggleDetail = () => setDetailsModal(!details_modal);
  const toggleSync = () => setSyncModal(!sync_modal);

  const connect_to = (url, app) => {
    apps_client.get(`settings/${app.settings.id}`).then((resp) => {
      setIsLoading(true)
      const isSet = !Object.entries(resp.data).some(([key, value]) => (value == null || value === '') && required_settings.includes(key));
      if (isSet && resp.data.UseTracking) {
        if (!resp.data.TrackingCategoryName) {
          NotificationManager.error(t('Please add first the tracking category name you wish to use on Xero'))
          setIsLoading(false)
          return null
        }
      }
      if (isSet) {
        if (app.in_connect) {
          inConnect(url, app)
        } else {
          outConnect(url, app)
        }
      } else {
        NotificationManager.error(t('Please complete the settings first'))
        setIsLoading(false)
        return null
      }
    })
  }

  const outConnect = (url, app) => {
    apps_client.get(url).then((resp) => {
      window.location.href = resp.data.url;
    })
  }

  const inConnect = (url, app) => {
    setIsLoading(true)
    apps_client.get(`connections/generate_url`, { params: { type: app.type } }).then((resp) => {
      apps_client.get(`connections/connect?${resp.data.url}`).then((resp) => {
        window.location.href = resp.data.url;
      })
    })
    setIsLoading(false)
  }

  const disconnect = (url, app) => {
    setIsLoading(true)
    apps_client.get(url).then((resp) => {
      NotificationManager.success(
        t("Disconnected Successfully", {})
      )
      getApps()
      setIsLoading(false)
    }).catch((err) => {
      NotificationManager.error(
        t("Couldn't Disconnect", {})
      )
      setIsLoading(false)
    })
  }

  const launchSetup = () => {
    setIsLoading(true)
    apps_client.get('applications/start_setup').then((resp) => {
      NotificationManager.success(
        t("Setup Completed", {})
      )
      getApps()
      setIsLoading(false)
    }).catch((err) => {
      NotificationManager.error(
        t("Setup Couldn't Complete", {})
      )
      setIsLoading(false)
    })
  }

  const restartSetup = () => {
    setIsLoading(true)
    apps_client.get('applications/restart_setup').then((resp) => {
      NotificationManager.success(
        t("Applications Are restarted", {})
      )
      getApps()
      setIsLoading(false)
    }).catch((err) => {
      NotificationManager.error(
        t("Setup Couldn't Complete", {})
      )
      setIsLoading(false)
    })
  }

  const getApps = () => {
    setIsLoading(true)
    apps_client.get(`applications`).then((resp) => { 
      setApps(resp.data)
    })
    apps_client.get(`non_subscribed`).then((resp) => { 
      setNonApps(resp.data)
    })
    setIsLoading(false)
  }


  useEffect(() => {
    getApps()
    setDomReady(true)
  }, [])

  const goToCustomizeSubscriptionPage = (type) => {
    history.push({
      pathname: '/customize-subscription',
      search: `from=app` + (type ? `&app_name=${type}` : '')
    })
  }

  const subscribedApps = selectedOrganisation?.subscribed_features?.hesaabapplication
  const hasApplications = subscribedApps?.length > 0
  const isTrial = user.isInTrialPeriod

  const nonAppsFiltered = nonApps?.nonsubscribed_applications?.filter(i => !subscribedApps.includes(i.type)) || []
  const allApps = [...apps, ...nonAppsFiltered]
  const filteredApps = allApps?.filter((item) =>  item?.type?.toLowerCase()?.includes(search?.toLowerCase()))

  return domReady ? (
    <Page >
      {/* {(hasModules || hasLanguages) &&
        <div className="mt-2 float-right">
          <Button size="sm" color="primary" onClick={() => goToCustomizeSubscriptionPage()}><Trans>Buy Application</Trans></Button>
        </div>
      } */}

      <BackButton />
      <div className="text-center">
        <div className="row">
          <div className="col position-relative" >
            <img src="/images/applications/appstore-background.jpg" alt="" class="img-fluid"/>
            <div className="row position-absolute justify-content-center w-100" style={{bottom:"20%"}}>
              <div className="col-5">
                <Input
                  className="form-control my-3 shadow py-4 bg-white"
                  placeholder={t("Enter an application name")}
                  type="text"
                  value={search}
                  onChange={(e) =>setSearch(e.target.value)}
              />
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="m-3">
        {/* <button onClick={test}>TEST</button> */}
        {isLoading &&
          createPortal(
            <div className="content">
              <div className="loader"></div>
              {/* <p>{text}</p> */}
            </div>,
            document.querySelector('#loader-holder')
          )
        }
      </div>
      {<div className="setup-container my-3 d-flex">
        { !apps?.length ? (hasApplications ? 
            <button className="btn btn-secondary mx-0" onClick={launchSetup}><Trans>Launch SetUp</Trans></button>
            :
            <div className="container text-center">
              <h4><Trans>{t(`You haven't purchased any application.`)}</Trans></h4>
            </div>)
          :
          null
        }
      </div>}
      <div  className="">
        {!allApps ?
          <div className="container text-center">
            <Trans>Loading</Trans> ....
          </div>
          :
          <>
          {filteredApps.length ? 
          <div className="row">
                  {filteredApps?.map((app) => (
                    <div key={app.id} className="col-md-6 col-12">
                      <Card outline className="shadow-sm border"
                      >
                        <CardBody>
                          <div className="row">
                            <div className="col-2 d-flex">
                              {app?.store && <img src={app?.store?.name ? (app.store.avatar ? app?.store?.avatar : store_logo ) : require(`../../assets/images/applications/${app?.store?.avatar}`).default}
                                className="m-auto" alt="" width={60} />}
                            </div>
                            <div className="col-10" style={{ borderInlineStart: "2px solid #e9ecef" }}>
                              <div className="row">
                                <div className="col-8">
                                  <CardTitle tag="h5">
                                    <Trans>Manage your {titleCase(app?.type)} Store </Trans>
                                  </CardTitle>
                                  <CardText className="mb-2 text-muted mb-0" style={{ height: "45px" }}>
                                    {app.is_active ?
                                      <div>
                                        <span><Trans>All is set, Your <strong>{app.store?.name}</strong> Store is synchronized with Xero</Trans></span>
                                      </div>
                                      :
                                      <>
                                      <span><Trans>Connect your <strong>{titleCase(app.type)}</strong> Store to benefit from New accounting features</Trans></span>
                                        {
                                          app?.type==="salla" &&
                                          <p>
                                            <Trans>Extra charges of 500 SAR will apply for the first time</Trans>
                                          </p>
                                        }
                                      </>
                                    }
                                  </CardText>
                                  <p className="mb-0"><a href={app?.store?.domain} className="link text-success" target="_blank">{app.is_active ? <Trans>Visit Store</Trans> : ""}&nbsp;</a></p>
                                </div>
                                <div className="col-4 text-right">
                                  {app.is_active ?
                                    <button className="btn btn-warning" onClick={() => { disconnect(app.disconnect_url, app) }}><Trans>Disconnect</Trans></button>
                                    :
                                    <>
                                      {isTrial || subscribedApps?.includes(app.type) ?
                                        <button className="btn btn-primary" onClick={() => { connect_to(app.connect_url, app) }}><Trans>Connect</Trans></button>
                                        :
                                        <button className="btn btn-outline-success" onClick={() => goToCustomizeSubscriptionPage(app?.type)}><Trans>Buy Now</Trans></button>
                                      }
                                    </>
                                  }
                                  
                                </div>
                              </div>
                            </div>
                          </div>

                        </CardBody>
                        <CardFooter>
                          <div className="row">
                            <div className="col">
                              <div className="buttons-container d-flex">
                                {app.settings ? 
                                  <Button className="ml-0" onClick={() => { toggleSettings(); setCurrent(app.settings.id) }}>
                                    <Trans>Settings</Trans>
                                  </Button> 
                                  :
                                  <Button outline className="ml-0" onClick={() => { toggleDetail(); setCurrent(app) }}><Trans>Details</Trans></Button>
                                }
                                {app.is_active ?
                                  <div className="col">
                                    <Button className="ml-0 btn btn-primary" onClick={() => { toggleSync(); setCurrent(app.id); setShowDateField(!!dateFieldRequired[app.type]); }}>
                                      <Trans>Sync</Trans>
                                    </Button>
                                  </div>
                                  :
                                  null
                                }
                              </div>
                            </div>
                            <div className="col d-flex align-items-center justify-content-end">
                              <div className="status text-muted">
                                {app.is_active ?
                                  <span><i className="fas fa-check mx-1" style={{ fontSize: '0.7rem' }}></i><Trans>Installed</Trans></span>
                                  :
                                  <Trans>Not Installed</Trans>
                                }

                              </div>
                            </div>
                          </div>
                        </CardFooter>
                      </Card>
                    </div>
                  )
                  )
                  }
          </div>
          :
          <div style={{fontSize:'1.3em'}} className="text-center text-muted p-3"><Trans>No Applications Found</Trans></div>
          }
          </>          
        }
        <SettingsModal modal={settings_modal} toggle={toggleSettings} t={t} id={current} setLoading={setIsLoading} />
        <DetailModal modal={details_modal} toggle={toggleDetail} t={t} app={current} />
        <SyncModal modal={sync_modal} toggle={toggleSync} t={t} id={current} showDateField={showDateField} setLoading={setIsLoading} />
      </div>

      <Card outline className="border shadow-sm">
        <CardBody>
          <ConfiguredIntegrations />
          <AvailableIntegrations />
        </CardBody>
      </Card>
    </Page>
  )
    :
    null
}


export default ApplicationsList;
